import { NotifyHelper } from './../../../helpers/toast';
import { eEmailFormDefine } from "../../action-types/email/IEmailFormActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const emailFormActions = {
    ...generateActions(eEmailFormDefine, "EMAIL_FORM"),
    ...generateActionForKey(eEmailFormDefine, "EMAIL_FORM",
        "SAVE_EMAIL_SUCCESS", () => NotifyHelper.Success("Saved")
    ),
    ...generateActionForKey(eEmailFormDefine, "EMAIL_FORM",
        "SAVE_EMAIL_ERROR", (m) => NotifyHelper.Error(m)
    )

}